import { useUtilityContext } from '@Context/prompt-toolbox/UtilityContext';

interface Props {
  onShare: () => void;
}

const SharePrompt: React.FC<Props> = ({ onShare }) => {
  const { setModal } = useUtilityContext();

  return (
    <div>
      <span className="flex flex-col gap-y-10">
        <label>This will share the prompt version to the library.</label>
        <span className="flex flex-row items-center justify-end gap-x-2">
          <button data-testid="share-modal-button"
            onClick={onShare}
            className="rounded-md bg-primary-700 px-4 py-2 text-white"
          >
            Share
          </button>
          <button data-testid="share-modal-cancel-button"
            onClick={() => setModal('sharePrompt', false)}
            className="rounded-md bg-brandRed-300 px-4 py-2 text-white"
          >
            Cancel
          </button>
        </span>
      </span>
    </div>
  );
};

export default SharePrompt;
